import styles from './Body.module.css';
import MessageSender from './MessageSender/MessageSender';
import Messages from './Messages/Messages';
import FormOverlay from '../../ConversationalForms/FormOverlay';
import FormsHeader from '../../ConversationalForms/FormsHeader';
import QuickReplyChips from '../../ConversationalForms/QuickReplyChips';
import { useConversationalForms } from '../../ConversationalForms/FormsContext';
import { formsThemeVars } from '../../ConversationalForms/theming';

function Body() {
  const { active, theme, state, formViewOpen, closeFormView, reviewFormId } =
    useConversationalForms();

  // The feature's CSS variables are set once here so every surface below —
  // pinned card, receipts inside messages, chips — themes from the two tenant
  // config colors with no per-component override. Absent the feature, no vars
  // and no extra markup are emitted.
  const themeVars = active ? formsThemeVars(theme) : undefined;

  // The overlay exists while a form is pinned, or (forms-corrections slice)
  // while a submitted form is open for review — the latter never pins, so it
  // needs its own gate alongside the pinned one. Discarding the pinned form
  // (or the form going away) drops the pinned case back to the conversation;
  // review is independent of that.
  const overlayOpen =
    formViewOpen && active && (state.activeFormId !== null || reviewFormId !== null);

  return (
    <div className={styles.chatBody} id="chatBody" style={themeVars}>
      {/* Pinned card plus, for multiform tenants only, the queue rows, menu,
          and the collapsed Your Forms bar. */}
      <FormsHeader />
      <Messages></Messages>
      <QuickReplyChips />
      <MessageSender />
      {overlayOpen && <FormOverlay onClose={closeFormView} />}
    </div>
  );
}
export default Body;
